import _ from 'lodash';
import React, { Component } from 'react';
import moment from 'moment'
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import gtag, { install } from 'ga-gtag';
import { db } from '../../firebase';
import 'whatwg-fetch';
import validator from 'email-validator'
import request from 'request';
//import moment from 'moment'

import PayjpCheckout from 'react-payjp-checkout';
//import card_errors from "../../data/system/error/card.json";

import signups from "../../data/signup.json";
import menus from "../../data/menu.json";
import apartments from "../../data/apartment.json";
const signups_labels = {"age": "年代", "sex": "性別", "family": "家族構成", "cleaning_frequency": "掃除頻度", "children": "子供", "pet": "ペット"}
const lots = [60, 120, 180]

const week = {
  en: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
  jp: ["月", "火", "水", "木", "金", "土", "日"]
}

const price = [3300, 5500, 8800]

var MY_SLACK_WEBHOOK_URL = process.env.REACT_APP_SLACK_WEBHOOK_URL;
var slack = require('slack-notify')(MY_SLACK_WEBHOOK_URL);
slack.onError = function (err) {
  console.log('API error:', err);
};

export default class Web extends Component {
  constructor (props) {
    super(props);

    this.state = {
      uuid: "",
      amount: 2750,
      family_name: "",
      first_name: "",
      family_name_kana: "",
      first_name_kana: "",
      zipcode: "",
      address: "",
      apartment: "",
      vip:[],
      tel: "",
      email: "",
      age: "2",
      sex: "1",
      family: "0",
      cleaning_frequency: "0",
      children: "0",
      pet: "0",
      use: "1",
      lot: 0,
      menu: "",
      menu_check: {1: 0, 2: 0, 3: 0, 4: 0, 5: 0},
      menu_etc: "",
      menu_etc_class: "hide",
      total_time: 0,
      schedule_check: [{am:1, pm:1}, {am:1, pm:1}, {am:1, pm:1}, {am:1, pm:1}, {am:1, pm:1}, {am:1, pm:1}, {am:1, pm:1}],
      schedule: "月曜日 午前午後、火曜日 午前午後、水曜日 午前午後、木曜日 午前午後、金曜日 午前午後、土曜日 午前午後、日曜日 午前午後",
      payjp_token: "",
      terms: 0,
      privacy: 0,
      covid: 0,
      policy: 0,
      campaign: "",
      casts: {},
      slots: {30: [], 60: [], 90: [], 120: [], 150: [], 180: []},
      slot: [],
      slot_etc: "",
      pre_reservation_casts: [],
      pre_reservation_dates: [],
      on_submit: false,
      errors: {}
    };
  }

  componentDidMount () {
    window.scrollTo(0, 0);
    let uuid = "direct"
    if (this.props.location.state) {
      uuid = this.props.location.state.uuid
    }
    this.setState({uuid: uuid})

    let campaign = "trial"
    if (this.props.location.state) {
      if (this.props.location.state.campaign) {
        campaign = this.props.location.state.campaign.substr(1)
      }
    }
    this.setState({campaign: campaign})
  
    if ("30min.page" === document.domain) {
      ReactGA.initialize('UA-184751599-1');
      ReactGA.pageview(window.location.pathname + window.location.search);

      install('AW-404081375');
      gtag('config', 'AW-404081375');

      ReactPixel.init('750234562329469');
      ReactPixel.pageView();
    }

    var scope = this
    var casts = {}
    db.ref('casts').on('value', snapshot => {
      casts = snapshot.val()
      //console.log(casts)
      scope.setState({ casts: casts })
    });

    db.ref('schedules').on('value', snapshot => {
      var schedules_tmp = snapshot.val()
      //console.log(schedules_tmp)
      var schedules = []
      for (let i in schedules_tmp) {
        for (let k in schedules_tmp[i]) {
          if ("true" === schedules_tmp[i][k].repeat) {
            // 週の差分
            let week_diff = Math.ceil(moment().add(1, "week").diff(schedules_tmp[i][k].start, 'days') / 7)
            //console.log(moment().format("YYYY/MM/DD(dddd)HH:mm"), moment(schedules_tmp[i][k].start).format("YYYY/MM/DD(dddd)HH:mm"), week_diff)
            
            // repeatになってるやつは差分週からの4週分入れる
            for (let n = week_diff; n < week_diff + 4; n++) {
              let start = moment(schedules_tmp[i][k].start).add(n, "week").valueOf()
              let end = moment(schedules_tmp[i][k].end).add(n, "week").valueOf()
              let arr = {start: start, end: end, createdAt: schedules_tmp[i][k].createdAt, repeat: "true", cast_id: i}
              schedules.push(arr)
            }
          } else {
            if (moment().valueOf() < schedules_tmp[i][k].start) {
              schedules.push(Object.assign(schedules_tmp[i][k], {cast_id: i}))
            }
          }
        }
      }

      // 順番並び替え
      schedules.sort(function(a, b) {
        if (a.start > b.start) {
          return 1;
        } else {
          return -1;
        }
      })

      //console.log(schedules)

      // 30分区切りで配列化
      var slots = {}
      for (let i in lots) {
        let lot = lots[i]
        slots[lot] = []
        var lot_time = lot * 60 * 1000 // 30分=30*60秒*1000ミリ
        for (let i in schedules) {
          for (let t = 0; lot_time <= (schedules[i].end - schedules[i].start - t); t += 1800000) {
            let t_id = schedules[i].start + t
            if (slots[lot][t_id]) {
              slots[lot][t_id]["casts"].push(schedules[i]["cast_id"])
            } else {
              slots[lot][t_id] = {start: t_id, casts: [schedules[i]["cast_id"]]}
            }
          }
        }
      }

      //console.log("slots",slots)

      scope.setState({ slots })
      
    });
  }

  setApartment (apartment) {
    let vip = []
    if (apartment !== "") {
      vip = apartments.filter(vip => {
        let ret
        let regex = new RegExp(apartment + '(.*?)', 'g')
        if (regex.test(vip)) {
          ret = vip
        }
        return ret
      })
    }
    this.setState({apartment: apartment, vip: vip})
  }

  setVip (apartment) {
    let vip = []
    this.setState({apartment: apartment, vip: vip})
    this.apartmentInput.focus()
  }

  setCheck (name, check) {
    var v = 0
    if (check === true) {
      v = 1
    }
    this.setState({[name]: v})
  }

  setSlot (i, slot, casts) {
    var slots = this.state.slot
    slots[i] = slot
    console.log(slots);

    console.log(casts);

    var pre_reservation_casts = this.state.pre_reservation_casts
    if (casts.indexOf(',') !== -1) {
      pre_reservation_casts[i] = casts.split(',')
    } else {
      pre_reservation_casts[i] = [casts]
    }

    this.setState({slot: slots, pre_reservation_casts: pre_reservation_casts})
  }

  setMenuCheck (id, check) {
    var menu_check = this.state.menu_check
    var menu = ""
    var total_time = 0
    for (let i in menu_check) {
      if (id === i) {
        if (check === true) {
          menu_check[i] = 1
        } else {
          menu_check[i] = 0
        }
      }
      if (menu_check[i] === 1) {
        if (menu !== "") {
          menu += "、"
        }
        let m = menus.find(m => m.id === i)
        menu += m.title
        total_time += parseInt(m.time)
      }
    }
    var menu_etc_class = "hide"
    if (menu_check[5] === 1) {
      menu_etc_class = "show"
    }
    this.setState({menu_check:menu_check, menu, menu_etc_class: menu_etc_class, total_time: total_time})
  }

  setScheduleCheck (id, time, check) {
    var schedule_check = this.state.schedule_check
    var schedule = ""
    for (let i in schedule_check) {
      if (id === parseInt(i, 10)) {
        if (check === true) {
          if (time === "all") {
            schedule_check[i]["am"] = 1
            schedule_check[i]["pm"] = 1
          } else {
            schedule_check[i][time] = 1
          }
        } else {
          if (time === "all") {
            schedule_check[i]["am"] = 0
            schedule_check[i]["pm"] = 0
          } else {
            schedule_check[i][time] = 0
          }
        }
      }
      if (schedule_check[i]["am"] === 1 || schedule_check[i]["pm"] === 1) {
        if (schedule !== "") {
          schedule += "、"
        }
        let schedule_tmp = ""
        if (schedule_check[i]["am"]) {
          schedule_tmp += "午前"
        }
        if (schedule_check[i]["pm"]) {
          schedule_tmp += "午後"
        }
        schedule += week["jp"][i] + "曜日 " + schedule_tmp
      }
    }
    this.setState({schedule_check:schedule_check, schedule})
  }

  setCard(e) {
    if (e.token) {
      this.setState({payjp_token: e.token})
    }
  }

  validation (e) {

    // ボタン押下時点でイベント記録
    var event_info = _.cloneDeep(this.state);
    event_info.createdAt = Date.now();
    //db.ref(`log/event/lp/`).push(event_info);

    //console.log(this.state)
    var errors = {}

    // ユーザー名　入力　50文字以内
    if (this.state.family_name === "" || this.state.first_name === "") {
      errors["name"] = "氏名を入力してください"
    } else if (this.state.family_name.length > 50 || this.state.first_name.length > 50) {
      errors["name"] = "氏名は50文字以内で入力してください。";
    }
    if (this.state.family_name_kana === "" || this.state.first_name_kana === "") {
      errors["name_kana"] = "フリガナを入力してください"
    } else if (this.state.family_name_kana.length > 50 || this.state.first_name_kana.length > 50) {
      errors["name_kana"] = "フリガナは50文字以内で入力してください。";
    }

    // 郵便番号　入力　郵便番号チェック
    if (this.state.zipcode === "") {
      errors["zipcode"] = "郵便番号を入力してください。";
    } else if (!this.state.zipcode.match(/^[0-9,-]+$/)) {
      errors["zipcode"] = "郵便番号を正しく入力してください。";
    }

    // 住所　入力　50文字チェック
    if (this.state.address === "") {
      errors["address"] = "住所を入力してください。";
    } else if (this.state.address.length > 50) {
      errors["address"] = "住所は50文字以内で入力してください。";
    }

    // マンション名・部屋番号　入力　100文字チェック
    if (this.state.apartment === "") {
      errors["apartment"] = "マンション名・部屋番号を入力してください。";
    } else if (this.state.apartment.length > 100) {
      errors["apartment"] = "マンション名・部屋番号は100文字以内で入力してください。";
    }

    // 電話番号　入力　電話番号チェック（簡易版: 数字ハイフン,8~16文字）
    if (this.state.tel === "") {
      errors["tel"] = "電話番号を入力してください。";
    } else if (!this.state.tel.match(/^[0-9,-]+$/)) {
      errors["tel"] = "電話番号を正しく入力してください（半角数字もしくはハイフン以外の入力はできません）。";
    } else if (8 > this.state.tel.length || 16 < this.state.tel.length) {
      errors["tel"] = "電話番号を正しく入力してください。";
    }

    // メールアドレス　入力　メールアドレスチェック
    if (this.state.email === "") {
      errors["email"] = "メールアドレスを入力してください。";
    } else if(!validator.validate(this.state.email)) {
      errors["email"] = "メールアドレスを正しく入力してください。";
    }

    // 年代、性別、家族構成、掃除頻度、子供、ペット
    for (let x in signups_labels) {
      var error = 1
      for(let i = 0; i < signups[x].length; i++) {
        if (parseInt(this.state[x], 10) === i) {
          error = 0
        }
      }
      if (error) {
        errors[x] = signups_labels[x] + "を選択してください。";
      }
    }

    // 希望の掃除内容　入力　10000文字チェック
    if (this.state.menu === "") {
      errors["menu"] = "ご希望の掃除内容を選択してください。";
    } else if (this.state.menu.length > 10000) {
      errors["menu"] = "ご希望の掃除内容を正しく選択してください。";
    } 
    if (this.state.menu_etc.length > 10000) {
      errors["menu"] = "ご希望の掃除内容（その他）は10000文字以内で入力してください。";
    }

    // 希望の時間数
    error = 1
    for(let i = 0; i < lots.length; i++) {
      if (parseInt(this.state.lot, 10) === i) {
        error = 0
      }
    }
    if (error) {
      errors["lot"] = "ご希望の時間数を選択してください。";
    }

    // 希望の曜日・時間
    if (this.state.slot === {} && this.state.slot_etc === "") {
      errors["slot"] = "ご希望の曜日・時間を選択または記入してください。";
    }

    //payjp-token
    if (this.state.payjp_token === "") {
      errors["card"] = "クレジットカード情報を入力してください。";
    }

    // 利用規約への同意
    if (this.state.terms !== 1) {
      errors["terms"] = "利用規約への同意が必要です。";
    }

    // プライバシーポリシーへの同意
    if (this.state.privacy !== 1) {
      errors["privacy"] = "プライバシーポリシーへの同意が必要です。";
    }

    // 新型コロナウィルスに係る対応への同意
    if (this.state.covid !== 1) {
      errors["covid"] = "新型コロナウィルスに係る対応への同意が必要です。";
    }

    // 個人情報の取り扱いについてへの同意
    if (this.state.policy !== 1) {
      errors["policy"] = "個人情報の取り扱いについての同意が必要です。";
    }

    this.setState({errors: errors}, () => {
      if (Object.keys(this.state.errors).length === 0) {
        this.send()
      }
    });
  }

  send(e) {
    if (this.state.on_submit === false) {
      db.ref('casts').on('value', snapshot => {
        //const casts = snapshot.val()
        this.setState({on_submit: true});

        var data = _.cloneDeep(this.state);
        data.createdAt = Date.now();

        var scope = this

        var user_id = db.ref(`lp/users/`).push().key

        const user_info = {
          id: user_id,
          family_name: data.family_name,
          first_name: data.first_name,
          family_name_kana: data.family_name_kana,
          first_name_kana: data.first_name_kana,
          zipcode: data.zipcode,
          address: data.address,
          apartment: data.apartment,
          tel: data.tel,
          email: data.email,
          age: parseInt(data.age, 10),
          sex: parseInt(data.sex, 10),
          family: parseInt(data.family, 10),
          cleaning_frequency: parseInt(data.cleaning_frequency, 10),
          children: parseInt(data.children, 10),
          pet: parseInt(data.pet, 10),
          use: parseInt(data.use, 10),
          menu: data.menu,
          menu_etc: data.menu_etc,
          schedule: data.schedule,
          campaign: data.campaign,
          payjp_id: data.payjp_token,
          uuid: this.state.uuid,
          createdAt: data.createdAt
        }

        const pre_reservation_info = {
          casts: data.pre_reservation_casts,
          dates: data.slot,
          user_id: user_id,
          lot: data.lot,
          menu: data.menu,
          menu_etc: data.menu_etc,
          createdAt: data.createdAt
        }

        console.log(pre_reservation_info)
        
        db.ref(`lp/users/` + user_id).update(user_info).then(function() {
          // ユーザー側にメール通知
          var sendgrid_url = process.env.REACT_APP_FUNCTIONS_URL + "/email"

          var ids = [user_id]
          var emails = [data.email]
          var title = "お申込みありがとうございます！／三菱地所の家事代行30min."
          var user_info_text = "氏名：" + user_info.family_name + " " + user_info.first_name + "\n年代：" + signups.age[user_info.age] + "\n性別：" + signups.sex[user_info.sex] + "\n家族構成：" + signups.family[user_info.family] + "\n掃除頻度：" + signups.cleaning_frequency[user_info.cleaning_frequency] + "\n子供：" + signups.children[user_info.children] + "\nペット：" + signups.pet[user_info.pet] + "\n"
          var menu_text = user_info.menu
          if (user_info.menu_etc) {
            if ("" !== menu_text) {
              menu_text += "、"
            }
            menu_text += "その他（" + user_info.menu_etc + "）"
          }
          var date_text = ""

          moment.updateLocale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
          for (let i = 0; i < pre_reservation_info.dates.length; i++) {
            if ("" !== date_text) {
              date_text += "、"
            }
            date_text += "第" + (i + 1) + "希望：" + moment(parseInt(pre_reservation_info.dates[i], 10)).format("YYYY/MM/DD(dddd)HH:mm")
          }
          var menu_info_text = "掃除内容：" + menu_text + "\n時間数：" + lots[pre_reservation_info.lot] + "分\n日時：" + date_text + "\n"
          //menus.find(m => m.id === data.menu).title
          var text = data.family_name + "さま\n初めまして。三菱地所の家事代行 30min.事務局でございます。\nこのたびは、お試しキャンペーンにお申込みいただき、ありがとうございます。\n\nお申し込み内容に沿ってスタッフを選定し、本日より最大６営業日以内に、訪問日をご提案いたしますので\n楽しみにお待ちください。\n\nご入力内容\n---\n" + user_info_text + menu_info_text + "\n---\n※ご記入いただいた内容に関して、事務局より別途メール・お電話にてご連絡差し上げる場合がございます。\nご承知置き頂ければと思います、宜しくお願い申し上げます。\n\nよろしくお願いいたします。\n----------------------------------------\n三菱地所の家事代行30min. 事務局\nthirty-min@mec.co.jp"
          //console.log(emails)

          var options3 = {
            uri: sendgrid_url,
            headers: {
              "Content-type": "application/json",
            },
            json: {
              "ids": ids,
              "emails": emails,
              "subject": title,
              "body": text
            }
          }

          request.post(options3, function(error, response, body){
            // キャスト側にメール通知
            //var title = "あなたに依頼が届きました／三菱地所の家事代行30min."

            var pre_reservation_id = db.ref(`pre_reservations/` + user_id).push().key
            db.ref(`pre_reservations/` + user_id + "/" + pre_reservation_id).update(pre_reservation_info).then(function() {

              scope.setState({on_submit: false});
              //slack.success('キャンペーンの申し込みがありました！\n氏名：' + data.family_name + ' ' + data.first_name + '（' + data.family_name_kana + ' ' + data.first_name_kana + '）');
              scope.props.history.push("/trial_done");

              /*Promise.all(pre_reservation_info.casts.map((pre_reservation_casts, i) => {
                return new Promise((resolve, reject) => {

                  menu_info_text = "掃除内容：" + menu_text + "\n時間数：" + lots[pre_reservation_info.lot] + "分\n日時：" + moment(parseInt(pre_reservation_info.dates[i], 10)).format("YYYY/MM/DD(dddd)HH:mm") + "\n"
                  
                  for (let n in pre_reservation_casts) {
                    var cast_id = n
                    var email = casts[pre_reservation_casts[n]].email
                    // メールのリンクは cast_agreement/pre予約ID/日付(第1〜3希望)/キャストID
                    var agreement_url = process.env.REACT_APP_PUBLIC_URL + "/cast_agreement/" + pre_reservation_id + "/" + i + "/" + cast_id
                    var text = "こんにちは、三菱地所の家事代行 30min.事務局でございます。\nあなた宛に掃除の依頼が届きました。\n\n■依頼内容\n" + menu_info_text + "\n\n承諾いただける場合は下記のリンクにアクセスしてください。\n" + agreement_url + "\n*承諾が早かったキャストにご依頼が行きます。\n他のキャストが先に承諾した場合はあなたへの依頼は取り下げられますのでご了承ください。\nよろしくお願いいたします。\n----------------------------------------\n三菱地所の家事代行30min. 事務局\nthirty-min@mec.co.jp"
                    var options4 = {
                      uri: sendgrid_url,
                      headers: {
                        "Content-type": "application/json",
                      },
                      json: {
                        "ids": cast_id,
                        "emails": email,
                        "subject": title,
                        "body": text
                      }
                    }
                    // メール送付(async)
                    request.post(options4, function(error, response, body) {
                      if (error) {
                        // An error happened.
                        reject("error")
                      } else {
                        resolve("success")
                      }
                    });
                  }
                });
              })).then(result => {
                scope.setState({on_submit: false});
                //slack.success('キャンペーンの申し込みがありました！\n氏名：' + data.family_name + ' ' + data.first_name + '（' + data.family_name_kana + ' ' + data.first_name_kana + '）');
                scope.props.history.push("/trial_done");
              }).catch(err => {
                scope.setState({on_submit: false, errors: {"server": "サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください"}});
                console.log(err)
              });
              */
            }).catch(err => {
              scope.setState({on_submit: false, errors: {"server": "サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください"}});
              console.log(err)
            });
          });
        }).catch(err => {
          scope.setState({on_submit: false, errors: {"server": "サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください"}});
          console.log(err)
        });
      });
    }
  }

  render () {
    const payjpCheckoutProps = {
        dataKey: process.env.REACT_APP_PAYJP_PUBLIC_KEY,
        dataText: 'クレジットカード情報を入力する',
        dataPartial: 'true',
        onCreatedHandler: e => this.setCard(e)
    }
    const vip_list = this.state.vip.map((v,i) => {
      return <p onClick={e => this.setVip(v)}>{v}</p>
    });
    const age_list = signups.age.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const sex_list = signups.sex.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const family_list = signups.family.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const cleaning_frequency_list = signups.cleaning_frequency.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const children_list = signups.children.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const pet_list = signups.pet.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const menu_list = menus.map((v, i) => {
      let checked = ""
      if (parseInt(this.state.menu_check[v.id], 10) === 1) {
        checked = "checked"
      }
      return <label key={i}><input type="checkbox" checked={checked} onChange={e => this.setMenuCheck(v.id, e.target.checked)} />{v.title}</label>;
    });
    const lot_list = lots.map((v, i) => {
      return <option key={i} value={i}>{v}分</option>;
    });
    moment.updateLocale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
    const schedule_list = _.values(this.state.slots[lots[this.state.lot]]).map((slot, i) => {
      let ret
      if (moment().add(1, "week").valueOf() < slot.start) {
        ret = <option key={i} value={slot.start} id={slot.casts}>{moment(slot.start).format("YYYY/MM/DD(dddd)HH:mm")}〜{moment(slot.start).add(lots[this.state.lot], "minute").format("HH:mm")}</option>;
      }
      return ret
    });
    return (
    <div className="web home">
      <div className="content-wrapper">
        <div className="trial-form-web">

          <div className="header">
            <p className="header-title">キャンペーンお申し込みフォーム</p>
          </div>

          <div className="content">
            <div className="label">氏名</div>
            <input type="text" name="family_name" className="input-s" value={this.state.family_name} onChange={e => this.setState({family_name: e.target.value})} placeholder="山田" /><input type="text" name="first_name" className="input-s" value={this.state.first_name} onChange={e => this.setState({first_name: e.target.value})} placeholder="花子" />
            <p className="error-message">{this.state.errors.name}</p>

            <div className="label">フリガナ</div>
            <input type="text" name="family_name_kana" className="input-s" value={this.state.family_name_kana} onChange={e => this.setState({family_name_kana: e.target.value})} placeholder="ヤマダ" /><input type="text" name="first_name_kana" className="input-s" value={this.state.first_name_kana} onChange={e => this.setState({first_name_kana: e.target.value})} placeholder="ハナコ" />
            <p className="error-message">{this.state.errors.name_kana}</p>

            <div className="label">郵便番号</div>
            <input type="text" name="zipcode" value={this.state.zipcode} onChange={e => this.setState({zipcode: e.target.value})} placeholder="123-4567" />
            <p className="error-message">{this.state.errors.zipcode}</p>

            <div className="label">住所</div>
            <input type="text" name="address" value={this.state.address} onChange={e => this.setState({address: e.target.value})} placeholder="東京都千代田区神田猿楽町１丁目２−２" />
            <p className="error-message">{this.state.errors.address}</p>

            <div className="label">マンション名・部屋番号</div>
            <input type="text" name="apartment" ref={(input) => {this.apartmentInput = input;}} value={this.state.apartment} onChange={e => this.setApartment(e.target.value)} placeholder="ザ・パークハウスアーバンス千代田御茶ノ水" />
            <div className="vip_list">{vip_list}</div>
            <p className="error-message">{this.state.errors.apartment}</p>

            <div className="label">電話番号</div>
            <input type="text" name="tel" value={this.state.tel} onChange={e => this.setState({tel: e.target.value})} placeholder="090-1234-5678" />
            <p className="error-message">{this.state.errors.tel}</p>

            <div className="label">メールアドレス</div>
            <input type="text" name="email" value={this.state.email} onChange={e => this.setState({email: e.target.value})} placeholder="yamada@gmail.com" />
            <p className="error-message">{this.state.errors.email}</p>

            <div className="label">年代</div>
            <select name="age" value={this.state.age} onChange={e => this.setState({age: e.target.value})}>
              {age_list}
            </select>
            <p className="error-message">{this.state.errors.age}</p>

            <div className="label">性別</div>
            <select name="sex" value={this.state.sex} onChange={e => this.setState({sex: e.target.value})}>
              {sex_list}
            </select>
            <p className="error-message">{this.state.errors.sex}</p>

            <div className="label">家族構成</div>
            <select name="family" value={this.state.family} onChange={e => this.setState({family: e.target.value})}>
              {family_list}
            </select>
            <p className="error-message">{this.state.errors.family}</p>

            <div className="label">掃除頻度</div>
            <select name="cleaning_frequency" value={this.state.cleaning_frequency} onChange={e => this.setState({cleaning_frequency: e.target.value})}>
              {cleaning_frequency_list}
            </select>
            <p className="error-message">{this.state.errors.cleaning_frequency}</p>

            <div className="label">子供</div>
            <select name="children" value={this.state.children} onChange={e => this.setState({children: e.target.value})}>
              {children_list}
            </select>
            <p className="error-message">{this.state.errors.children}</p>

            <div className="label">ペット</div>
            <select name="pet" value={this.state.pet} onChange={e => this.setState({pet: e.target.value})}>
              {pet_list}
            </select>
            <p className="error-message">{this.state.errors.pet}</p>

            <div className="label">ご希望の掃除内容</div>
            <div className="menu_list">
              {menu_list}
            </div>
            <br className="clear" />
            <p className="error-message">{this.state.errors.menu}</p>
            <p className="description">時間数の目安：{this.state.total_time}分</p>
            <br />

            <div className="label">ご希望の時間数</div>
            <select name="lot" onChange={e => this.setState({lot: e.target.value})}>
              {lot_list}
            </select>
            <p className="description">{[this.state.total_time > lots[this.state.lot] ? "時間数の目安を超えています（あくまで標準時間での目安であり、広さ・汚れ等によって時間数は変わるためご予約は可能です）" : ""]}</p>
            <p className="error-message">{this.state.errors.lot}</p>
            <br />

            <div className="label">ご希望の日時</div>
            <div className="schedule_list">
              <select onChange={e => this.setSlot(0, e.target.value, e.target[e.target.selectedIndex].id)}>
                <option>第1希望</option>
                {schedule_list}
              </select>
              <select onChange={e => this.setSlot(1, e.target.value, e.target[e.target.selectedIndex].id)}>
                <option>第2希望</option>
                {schedule_list}
              </select>
              <select onChange={e => this.setSlot(2, e.target.value, e.target[e.target.selectedIndex].id)}>
                <option>第3希望</option>
                {schedule_list}
              </select>
              <textarea placeholder="その他（上記にご希望の日時がない場合、ご希望の日時をいくつかご記載ください）" onChange={e => this.setState({slot_etc: e.target.value})} />
            </div>
            <br className="clear" />
            <p className="error-message">{this.state.errors.slot}</p>

            {/*<p>初回金額{this.state.amount.toLocaleString()}円　月額{(this.state.amount * 4).toLocaleString()}円</p>*/}

            <div className="label">クレジットカード情報</div>
            <div className="description">{price[this.state.lot].toLocaleString()}円（{lots[this.state.lot]}分の料金）が清掃実施後にご登録のカードから引き落とされます</div>
            <div className="payjpButtonArea">
              <PayjpCheckout {...payjpCheckoutProps} />
            </div>
            <p className="error-message">{this.state.errors.card}</p>
            <br />

            <label><input name="terms" className="checkbox-margin" type="checkbox" checked={this.state.terms} onChange={e => this.setCheck("terms", e.target.checked)} /><a href="https://f.hubspotusercontent30.net/hubfs/7085787/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E2%80%97%E6%B3%95%E4%BA%BA%E8%BF%BD%E5%8A%A0%E6%9C%80%E7%B5%82%E7%89%88.pdf" target="_blank" rel="noopener noreferrer">利用規約</a>に同意する</label>
            <p className="error-message">{this.state.errors.terms}</p>

            <label><input name="privacy" className="checkbox-margin" type="checkbox" checked={this.state.privacy} onChange={e => this.setCheck("privacy", e.target.checked)} /><a href="https://www.mec.co.jp/j/privacy/" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に同意する</label>
            <p className="error-message">{this.state.errors.privacy}</p>

            <label><input name="covid" className="checkbox-margin" type="checkbox" checked={this.state.covid} onChange={e => this.setCheck("covid", e.target.checked)} /><a href="https://f.hubspotusercontent30.net/hubfs/7085787/%E6%96%B0%E5%9E%8B%E3%82%B3%E3%83%AD%E3%83%8A%E3%82%A6%E3%82%A3%E3%83%AB%E3%82%B9%E3%81%AB%E4%BF%82%E3%82%8B%E5%AF%BE%E5%BF%9C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6.pdf" target="_blank" rel="noopener noreferrer">新型コロナウィルスに係る対応について</a>に同意する</label>
            <p className="error-message">{this.state.errors.covid}</p>

            <label><input name="policy" className="checkbox-margin" type="checkbox" checked={this.state.policy} onChange={e => this.setCheck("policy", e.target.checked)} />下記の「個人情報の取り扱いについて」に同意する</label>
            <p className="error-message">{this.state.errors.policy}</p>
          </div>

          <div className="form-precautions">
            <div className="precaution">
              <p className="precaution-title">【個人情報の取り扱いについて】</p>
              <p>当社は個人情報等に関する法令及びガイドライン等を遵守して、個人情報等の適正な取り扱いを行います／本フォームで取得した情報は当社の家事代行サービスに係るサービスの告知やサービスの提供、又サービス品質の向上の為のアンケートやインタビュー依頼の目的で利用させて頂きます／当社は上記に記載の目的の達成に必要な範囲で<a href="https://www.mec.co.jp/j/investor/irlibrary/financial/index.html">有価証券報告書</a>または<a href="https://www.mec.co.jp/j/company/group/field.html">グループ会社一覧</a>に記載の当社グループ会社と個人情報を共同利用することがあります。その場合の個人情報は登録フォームの全ての項目となり、管理責任の所在は、当社となります／当社はお客様から頂いた情報について、守秘義務を締結の上、業務委託先に対して提供することがあります／事業検証の経過・結果の一部を外部に開示する可能性がありますが、その場合、個人を特定されない形に集計して利用致します</p>
              <p>※本件及び本件に係る個人情報の取り扱いについてのお問い合わせ先：三菱地所株式会社・住宅業務企画部　<a href="mailto:thirty-min@mec.co.jp">thirty-min@mec.co.jp</a></p>
            </div>
          </div>

          <br />
          <div className="content">
            <div className="label">ご質問</div>
            <textarea placeholder="ご質問がある場合はこちらに入力ください。" onChange={e => this.setState({etc: e.target.value})} />
          </div>

          <div className="content">
            <p className="error-message">{this.state.errors.server}</p>
            <div className="buttons">
              <button id="registration" onClick={this.validation.bind(this)} className={[this.state.on_submit === true ? "on_submit" : ""]} disabled={this.state.on_submit}>お申し込み</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}